import { render, staticRenderFns } from "./shift-penalty-filters.vue?vue&type=template&id=52da3729&scoped=true"
import script from "./shift-penalty-filters.vue?vue&type=script&lang=js"
export * from "./shift-penalty-filters.vue?vue&type=script&lang=js"
import style0 from "./shift-penalty-filters.vue?vue&type=style&index=0&id=52da3729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da3729",
  null
  
)

export default component.exports